import { Validators } from "@angular/forms";
import { debounceTime, filter } from 'rxjs';
import { AxiosError } from "axios";
import { errorResponse } from "src/types/error-response";
import { NoticeControls, NoticeForm } from "../form.controls";
import { FormFactory } from "../form.factory";
import { Summary } from "../form.resources";

export function getNoticeForm(this: FormFactory): NoticeForm {
  const data = this.data as Summary;

  const form = this.fb.group<NoticeControls>({
    email: this.fb.control(data.debtor.email ?? '', { validators: [Validators.required, Validators.email], nonNullable: true }),
  });

  form.controls.email.valueChanges
    .pipe(
      debounceTime(1000),
      filter(() => form.controls.email.valid),
    )
    .subscribe({
      next: async (email) => {
        try {
          await this.formService.upsertDebtorContacts(email);
        } catch (error) {
          console.error('Error while upserting debtor contacts', error);
          if (error instanceof AxiosError) {
            const errorData = errorResponse.safeParse(error);
            if (errorData.success) {
              form.controls.email.setErrors({ unknown: errorData.data.message });
            }
          }
        }
      }
    });

  return form;
}
